// extracted by mini-css-extract-plugin
module.exports = {"p":"styles_p__PH532","emailWrapper":"styles_emailWrapper__b6NC7","queryHeading":"styles_queryHeading__K_N9g","email":"styles_email___OJpQ"};